import React from 'react';

function Container({ children, className }) {
  return <div className={`max-w-7xl w-full px-5 mx-auto ${className}`}>{children}</div>;
}

export default Container;
